/**
 * The Decisions v4 icon set, inlined from the design bundle's SVGs
 * (be-mark-successor `client/design/decision-screen/assets/`) plus the search,
 * sort, close and info glyphs the screens use. Every icon strokes
 * `currentColor`, so its colour follows the control it sits in.
 */

import type { ComponentChildren } from "preact";

interface IconProps {
  size?: number;
}

function Svg({ size = 16, children }: IconProps & { children: ComponentChildren }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 16 16"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      {children}
    </svg>
  );
}

export const CheckIcon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M13.3333 4L6 11.3333L2.66667 8" />
  </Svg>
);

export const ChevronDownIcon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 6L8 10L12 6" />
  </Svg>
);

export const ChevronUpIcon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M12 10L8 6L4 10" />
  </Svg>
);

export const SearchIcon = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="7" cy="7" r="4.75" />
    <path d="M10.5 10.5L14 14" />
  </Svg>
);

export const CloseIcon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 4L12 12M12 4L4 12" />
  </Svg>
);

export const SortIcon = (p: IconProps) => (
  <Svg {...p}>
    <path d="M5 13V3M5 3L2.5 5.5M5 3L7.5 5.5M11 3V13M11 13L8.5 10.5M11 13L13.5 10.5" />
  </Svg>
);

export const InfoIcon = (p: IconProps) => (
  <Svg {...p}>
    <circle cx="8" cy="8" r="6" stroke-width="1.5" />
    <path d="M8 7.25V11M8 5H8.01" stroke-width="1.5" />
  </Svg>
);
